module.exports = __webpack_public_path__ + "static/media/area.90da5b54.svg";